import { useEffect } from 'react';

import { action } from '../lib/actionHelpers.js';
import { useEvent } from '../hooks/index.js';
import { useSelector } from 'react-redux';
import selectors from '../selectors/selectors.js';
import postMockEvents from 'components/eventHandler/postMockEvents.js';
import inboxFoldersSelector from 'screens/inbox/store/inboxFoldersSelector.js';

const EventHandler = () => {
  const serviceProviderId = useSelector(selectors.serviceProviderId);
  const inboxFolders = useSelector(inboxFoldersSelector);
  let { events, setFetchMercureToken } = useEvent(serviceProviderId);

  const dev = process.env.NODE_ENV === 'development';

  useEffect(() => {
    events.onmessage = function (event) {
      action('GET_EVENT', {
        event,
        serviceProviderId: serviceProviderId,
        folders: inboxFolders,
      });
      const additionalAction = {
        updated_todo: 'GET_UPDATED_TODO_EVENT',
        updated_lead: 'GET_UPDATED_LEAD_EVENT',
        updated_pipeline_lead: 'GET_UPDATED_PIPELINE_LEAD_EVENT',
        updated_message: 'GET_UPDATED_MESSAGE_EVENT',
        lead_created: 'GET_UPDATED_LEAD_CREATION',
        count: 'GET_UPDATED_INBOX_COUNT',
        viewing_record: (event.data || {}).event_data && (event.data || {}).event_data['viewing_record'] ? 'viewing_record_SUCCESS' : 'clearviewing_record',
      }[(event.data || {}).type];

      if (!['viewing_record'].includes(additionalAction)) {
        console.info('Received event', additionalAction, 'data:', event.data);
      }
      if (additionalAction) {
        action(additionalAction, {
          event: (event.data || {}).event_data,
          serviceProviderId,
        });
      }
    };
    events.onerror = function (event) {
      if (event && (event || {}).tokenExpired === true) {
        setFetchMercureToken(true);
      }
    };
  }, [events, serviceProviderId]);

  useEffect(() => {
    if (dev) {
      // setInterval(postMockEvents, 300);
    }
  }, [dev]);

  return null;
};

export default EventHandler;
